const validationMessage = {
  REQUIRED: 'Required',
  INVALID: 'Invalid',
  BLOOD_GROUP_REQUIRED: 'Please select blood group',
};

export default validationMessage;
